import axios from "axios";
import {API_BASE_URL} from "../../services/config";

// get public profile by username
export const getPublicProfileService = async (username: string) => {
  const response = await axios.get(API_BASE_URL + "booking/mentor/" + username);

  return response.data;
};
